import React, { useEffect, useState } from "react";
import ProjectsCard from "./ProjectsCard";

const Projects = () => {
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    try {
      fetch("https://myportfolio1-server.vercel.app/projects")
        .then((res) => res.json())
        .then((data) => setProjects(data));
    } catch (err) {
      console.log(err);
    }
  }, []);
  return (
    <section id="projects" className="bg-main2 text-white">
      <div id="sectionTitle" className="sectionTitle pt-20 pb-10 text-center">
        <h2 className="text-5xl font-bold">Projects</h2>
      </div>
      <div className="container flex flex-col justify-center items-center p-6  sm:py-12 lg:py-24 lg:flex-row gap-5 mx-auto">
        {projects.map((project) => (
          <ProjectsCard key={project._id} project={project}></ProjectsCard>
        ))}
      </div>
    </section>
  );
};

export default Projects;
